
import { Navigation } from "@/components/Navigation";
import { Analytics } from "@/components/analytics/Analytics";
import { SEO } from "@/components/common/SEO";

export default function AnalyticsPage() {
  return (
    <>
      <SEO 
        title="Analytics & Reports - Hour Tracker"
        description="View detailed analytics, revenue reports, and time tracking insights for your projects and clients."
      />
      <div className="min-h-screen bg-background">
        <Navigation />
        <main className="pt-16">
          <div className="container mx-auto px-4 py-6">
            <div className="mb-6">
              <h1 className="text-3xl font-bold tracking-tight">Analytics & Reports</h1>
              <p className="text-muted-foreground mt-2">
                Track your productivity, revenue, and billable hours across projects and clients
              </p>
            </div>
            <Analytics />
          </div>
        </main>
      </div>
    </>
  );
}
